(() => {
  'use strict';

  /* PN8A_ADMIN_EVENTS_COMMUNITIES */

  const dashboard =
    document.querySelector(
      '[data-pnadm-dashboard]'
    );

  if (!dashboard) return;


  let generation = 0;

  let currentRows = {
    events:[],
    communities:[]
  };

  let colleges = [];

  let profiles = null;


  function body() {
    return dashboard.querySelector(
      '[data-pnops-body]'
    );
  }


  function meta() {
    return dashboard.querySelector(
      '[data-pnops-meta]'
    );
  }


  function activeTab() {

    return dashboard
      .querySelector(
        '[data-pnops-tab].is-active'
      )
      ?.dataset
      ?.pnopsTab || '';

  }


  function escapeHTML(value) {

    return String(
      value ?? ''
    )
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');

  }


  function clean(value) {

    return value === null ||
      value === undefined ||
      value === ''
        ? '—'
        : String(value);

  }


  function dateText(value) {

    if (!value) {
      return '—';
    }


    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return clean(value);
    }


    return date.toLocaleString(
      'en-IN',
      {
        dateStyle:'medium',
        timeStyle:'short'
      }
    );

  }


  function dateInput(value) {

    if (!value) {
      return '';
    }


    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '';
    }


    const shifted =
      new Date(
        date.getTime()
        -
        date.getTimezoneOffset()
        * 60000
      );


    return shifted
      .toISOString()
      .slice(0,16);

  }


  function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB
      .request(
        `rpc/${name}`,
        '',
        {
          method:'POST',
          body
        }
      );

  }


  function tableRequest(
    table,
    query
  ) {

    return window.PeerNestDB
      .request(
        table,
        query
      );

  }


  function refresh() {

    dashboard
      .querySelector(
        '[data-pnops-refresh]'
      )
      ?.click();

  }


  function eventRegistrationActive(
    status
  ) {

    return [
      'reserved',
      'payment_pending',
      'confirmed',
      'attended'
    ].includes(status);

  }


  function eventCounts(
    registrations
  ) {

    const counts =
      new Map();


    registrations.forEach(
      row => {

        if (
          !counts.has(
            row.event_id
          )
        ) {

          counts.set(
            row.event_id,
            {
              active:0,
              total:0
            }
          );

        }


        const item =
          counts.get(
            row.event_id
          );


        item.total += 1;


        if (
          eventRegistrationActive(
            row.status
          )
        ) {

          item.active += 1;

        }

      }
    );


    return counts;

  }


  function communityCounts(
    members
  ) {

    const counts =
      new Map();


    members.forEach(
      row => {

        if (
          !counts.has(
            row.community_id
          )
        ) {

          counts.set(
            row.community_id,
            {
              active:0,
              total:0
            }
          );

        }


        const item =
          counts.get(
            row.community_id
          );


        item.total += 1;


        if (
          row.status === 'active'
        ) {

          item.active += 1;

        }

      }
    );


    return counts;

  }


  function eventStatusActions(row) {

    const actions = [];


    if (
      row.status !== 'published'
    ) {

      actions.push(`
        <button
          type="button"
          data-pn8a-event-status="${escapeHTML(row.id)}"
          data-status="published"
        >
          Publish
        </button>
      `);

    }


    if (
      row.status !== 'draft'
    ) {

      actions.push(`
        <button
          type="button"
          data-pn8a-event-status="${escapeHTML(row.id)}"
          data-status="draft"
        >
          Draft
        </button>
      `);

    }


    if (
      row.status !== 'completed'
    ) {

      actions.push(`
        <button
          type="button"
          data-pn8a-event-status="${escapeHTML(row.id)}"
          data-status="completed"
        >
          Complete
        </button>
      `);

    }


    if (
      row.status !== 'cancelled'
    ) {

      actions.push(`
        <button
          type="button"
          class="pn8adm-btn--danger"
          data-pn8a-event-status="${escapeHTML(row.id)}"
          data-status="cancelled"
        >
          Cancel
        </button>
      `);

    }


    return actions.join('');

  }


  function eventCard(
    row,
    counts
  ) {

    const stats =
      counts.get(
        row.id
      )
      || {
        active:0,
        total:0
      };


    return `
      <article class="pn8adm-card">

        <div class="pn8adm-card__top">

          <div>

            <div class="pn8adm-eyebrow">
              ${escapeHTML(
                row.event_type
              )}
              ·
              ${escapeHTML(
                row.mode
              )}
            </div>

            <h3>
              ${escapeHTML(
                row.title
              )}
            </h3>

            <p>
              ${escapeHTML(
                row.slug
              )}
            </p>

          </div>


          <span
            class="pn8adm-state"
            data-state="${escapeHTML(
              row.status
            )}"
          >
            ${escapeHTML(
              row.status
            )}
          </span>

        </div>


        <div class="pn8adm-stats">

          <div>
            <small>STARTS</small>

            <strong>
              ${escapeHTML(
                dateText(
                  row.starts_at
                )
              )}
            </strong>
          </div>


          <div>
            <small>REGISTRATIONS</small>

            <strong>
              ${stats.active}
              active
            </strong>

            <span>
              ${stats.total}
              total
            </span>
          </div>


          <div>
            <small>CAPACITY</small>

            <strong>
              ${
                row.capacity === null
                  ? 'Unlimited'
                  : escapeHTML(
                      row.capacity
                    )
              }
            </strong>
          </div>


          <div>
            <small>PRICE</small>

            <strong>
              ${
                row.is_paid
                  ? `${escapeHTML(
                      row.currency ||
                      'INR'
                    )} ${escapeHTML(
                      row.price ||
                      0
                    )}`
                  : 'Free'
              }
            </strong>
          </div>

        </div>


        <div class="pn8adm-actions">

          <button
            type="button"
            class="pn8adm-btn--primary"
            data-pn8a-edit-event="${escapeHTML(
              row.id
            )}"
          >
            Edit
          </button>

          <button
            type="button"
            data-pn8a-inspect-event="${escapeHTML(
              row.id
            )}"
          >
            Registrations
          </button>

          ${eventStatusActions(row)}

        </div>

      </article>
    `;

  }


  function communityCard(
    row,
    counts
  ) {

    const stats =
      counts.get(
        row.id
      )
      || {
        active:0,
        total:0
      };


    return `
      <article class="pn8adm-card">

        <div class="pn8adm-card__top">

          <div>

            <div class="pn8adm-eyebrow">
              ${escapeHTML(
                row.category ||
                'COMMUNITY'
              )}
              ·
              ${escapeHTML(
                row.visibility
              )}
            </div>

            <h3>
              ${escapeHTML(
                row.name
              )}
            </h3>

            <p>
              ${escapeHTML(
                row.slug
              )}
            </p>

          </div>


          <span
            class="pn8adm-state"
            data-state="${
              row.is_published
                ? 'published'
                : 'draft'
            }"
          >
            ${
              row.is_published
                ? 'published'
                : 'archived'
            }
          </span>

        </div>


        <div class="pn8adm-stats">

          <div>
            <small>ACTIVE MEMBERS</small>

            <strong>
              ${stats.active}
            </strong>
          </div>


          <div>
            <small>MEMBERSHIPS</small>

            <strong>
              ${stats.total}
            </strong>
          </div>


          <div>
            <small>VISIBILITY</small>

            <strong>
              ${escapeHTML(
                row.visibility
              )}
            </strong>
          </div>


          <div>
            <small>COLLEGE</small>

            <strong>
              ${
                row.college_id
                  ? 'Linked'
                  : 'Platform-wide'
              }
            </strong>
          </div>

        </div>


        <div class="pn8adm-actions">

          <button
            type="button"
            class="pn8adm-btn--primary"
            data-pn8a-edit-community="${escapeHTML(
              row.id
            )}"
          >
            Edit
          </button>

          <button
            type="button"
            data-pn8a-inspect-community="${escapeHTML(
              row.id
            )}"
          >
            Members
          </button>

          <button
            type="button"
            data-pn8a-community-publish="${escapeHTML(
              row.id
            )}"
            data-published="${
              row.is_published
                ? 'false'
                : 'true'
            }"
          >
            ${
              row.is_published
                ? 'Archive'
                : 'Publish'
            }
          </button>

        </div>

      </article>
    `;

  }


  function managementHeader(
    type,
    count
  ) {

    const event =
      type === 'events';


    return `
      <div class="pn8adm-head">

        <div>
          <span>
            PHASE 8A
          </span>

          <h2>
            ${
              event
                ? 'Event management'
                : 'Community management'
            }
          </h2>

          <p>
            ${
              event
                ? 'Create, edit and control PeerNest events without touching payment processing.'
                : 'Create, publish and manage PeerNest student communities.'
            }
          </p>
        </div>


        <div class="pn8adm-head__right">

          <span>
            ${count}
            record${count === 1 ? '' : 's'}
          </span>

          <button
            type="button"
            class="pn8adm-create"
            data-pn8a-new="${
              event
                ? 'event'
                : 'community'
            }"
          >
            + New ${
              event
                ? 'Event'
                : 'Community'
            }
          </button>

        </div>

      </div>


      <div
        class="pn8adm-form-host"
        data-pn8a-form-host
      ></div>


      <div
        class="pn8adm-detail-host"
        data-pn8a-detail-host
      ></div>
    `;

  }


  function renderEventForm(
    row = {}
  ) {

    const editing =
      !!row.id;


    return `
      <form
        class="pn8adm-form"
        data-pn8a-event-form
      >

        <input
          type="hidden"
          name="id"
          value="${escapeHTML(
            row.id ||
            ''
          )}"
        >


        <div class="pn8adm-form__head">

          <div>
            <small>
              ${
                editing
                  ? 'EDIT EVENT'
                  : 'NEW EVENT'
              }
            </small>

            <h3>
              ${
                editing
                  ? escapeHTML(
                      row.title
                    )
                  : 'Create a PeerNest event'
              }
            </h3>
          </div>

          <button
            type="button"
            data-pn8a-close-form
          >
            ×
          </button>

        </div>


        <div class="pn8adm-form__grid">

          <label>
            <span>Title *</span>

            <input
              name="title"
              required
              value="${escapeHTML(
                row.title ||
                ''
              )}"
            >
          </label>


          <label>
            <span>Slug</span>

            <input
              name="slug"
              value="${escapeHTML(
                row.slug ||
                ''
              )}"
              placeholder="auto-generated if blank"
            >
          </label>


          <label>
            <span>Event type *</span>

            <select
              name="event_type"
              required
            >
              ${[
                'masterclass',
                'workshop',
                'ama',
                'webinar',
                'panel',
                'hackathon',
                'meetup',
                'college_event'
              ]
                .map(
                  value => `
                    <option
                      value="${value}"
                      ${
                        row.event_type === value
                          ? 'selected'
                          : ''
                      }
                    >
                      ${value.replaceAll('_',' ')}
                    </option>
                  `
                )
                .join('')}
            </select>
          </label>


          <label>
            <span>Mode *</span>

            <select
              name="mode"
              required
            >
              ${[
                'online',
                'offline',
                'hybrid'
              ]
                .map(
                  value => `
                    <option
                      value="${value}"
                      ${
                        row.mode === value
                          ? 'selected'
                          : ''
                      }
                    >
                      ${value}
                    </option>
                  `
                )
                .join('')}
            </select>
          </label>


          <label>
            <span>Starts *</span>

            <input
              type="datetime-local"
              name="starts_at"
              required
              value="${escapeHTML(
                dateInput(
                  row.starts_at
                )
              )}"
            >
          </label>


          <label>
            <span>Ends *</span>

            <input
              type="datetime-local"
              name="ends_at"
              required
              value="${escapeHTML(
                dateInput(
                  row.ends_at
                )
              )}"
            >
          </label>


          <label>
            <span>Registration deadline</span>

            <input
              type="datetime-local"
              name="registration_deadline"
              value="${escapeHTML(
                dateInput(
                  row.registration_deadline
                )
              )}"
            >
          </label>


          <label>
            <span>Capacity</span>

            <input
              type="number"
              min="1"
              name="capacity"
              value="${escapeHTML(
                row.capacity ??
                ''
              )}"
            >
          </label>


          <label>
            <span>Venue</span>

            <input
              name="venue"
              value="${escapeHTML(
                row.venue ||
                ''
              )}"
            >
          </label>


          <label>
            <span>Meeting URL</span>

            <input
              type="url"
              name="meeting_url"
              value="${escapeHTML(
                row.meeting_url ||
                ''
              )}"
            >
          </label>


          <label>
            <span>Cover image URL</span>

            <input
              type="url"
              name="cover_image_url"
              value="${escapeHTML(
                row.cover_image_url ||
                ''
              )}"
            >
          </label>


          <label>
            <span>Status</span>

            <select name="status">

              ${[
                'draft',
                'published',
                'cancelled',
                'completed'
              ]
                .map(
                  value => `
                    <option
                      value="${value}"
                      ${
                        (
                          row.status ||
                          'draft'
                        ) === value
                          ? 'selected'
                          : ''
                      }
                    >
                      ${value}
                    </option>
                  `
                )
                .join('')}

            </select>
          </label>


          <label class="pn8adm-form__wide">
            <span>Description</span>

            <textarea
              name="description"
              rows="4"
            >${escapeHTML(
              row.description ||
              ''
            )}</textarea>
          </label>


          <label class="pn8adm-form__wide">
            <span>Agenda</span>

            <textarea
              name="agenda"
              rows="4"
            >${escapeHTML(
              row.agenda ||
              ''
            )}</textarea>
          </label>


          <label class="pn8adm-check">

            <input
              type="checkbox"
              name="is_paid"
              ${
                row.is_paid
                  ? 'checked'
                  : ''
              }
            >

            <span>
              Paid event
              <small>
                Checkout remains disabled until Payment Pass.
              </small>
            </span>

          </label>


          <label>
            <span>Future price</span>

            <input
              type="number"
              min="0"
              step="0.01"
              name="price"
              value="${escapeHTML(
                row.price ??
                0
              )}"
            >
          </label>

        </div>


        <div class="pn8adm-form__actions">

          <button
            type="submit"
            class="pn8adm-btn--primary"
          >
            ${
              editing
                ? 'Save changes'
                : 'Create event'
            }
          </button>

          <button
            type="button"
            data-pn8a-close-form
          >
            Cancel
          </button>

        </div>

      </form>
    `;

  }


  function collegeOptions(
    selected
  ) {

    return `
      <option value="">
        No linked college
      </option>

      ${colleges
        .map(
          college => `
            <option
              value="${escapeHTML(
                college.id
              )}"
              ${
                selected === college.id
                  ? 'selected'
                  : ''
              }
            >
              ${escapeHTML(
                college.name
              )}
            </option>
          `
        )
        .join('')}
    `;

  }


  function renderCommunityForm(
    row = {}
  ) {

    const editing =
      !!row.id;


    return `
      <form
        class="pn8adm-form"
        data-pn8a-community-form
      >

        <input
          type="hidden"
          name="id"
          value="${escapeHTML(
            row.id ||
            ''
          )}"
        >


        <div class="pn8adm-form__head">

          <div>
            <small>
              ${
                editing
                  ? 'EDIT COMMUNITY'
                  : 'NEW COMMUNITY'
              }
            </small>

            <h3>
              ${
                editing
                  ? escapeHTML(
                      row.name
                    )
                  : 'Create a PeerNest community'
              }
            </h3>
          </div>

          <button
            type="button"
            data-pn8a-close-form
          >
            ×
          </button>

        </div>


        <div class="pn8adm-form__grid">

          <label>
            <span>Name *</span>

            <input
              name="name"
              required
              value="${escapeHTML(
                row.name ||
                ''
              )}"
            >
          </label>


          <label>
            <span>Slug</span>

            <input
              name="slug"
              value="${escapeHTML(
                row.slug ||
                ''
              )}"
              placeholder="auto-generated if blank"
            >
          </label>


          <label>
            <span>Category</span>

            <input
              name="category"
              value="${escapeHTML(
                row.category ||
                ''
              )}"
              placeholder="College, Career, Tech..."
            >
          </label>


          <label>
            <span>Visibility</span>

            <select name="visibility">

              ${[
                'public',
                'private',
                'college'
              ]
                .map(
                  value => `
                    <option
                      value="${value}"
                      ${
                        (
                          row.visibility ||
                          'public'
                        ) === value
                          ? 'selected'
                          : ''
                      }
                    >
                      ${value}
                    </option>
                  `
                )
                .join('')}

            </select>
          </label>


          <label>
            <span>College</span>

            <select name="college_id">
              ${collegeOptions(
                row.college_id
              )}
            </select>
          </label>


          <label>
            <span>Cover image URL</span>

            <input
              type="url"
              name="cover_image_url"
              value="${escapeHTML(
                row.cover_image_url ||
                ''
              )}"
            >
          </label>


          <label class="pn8adm-form__wide">
            <span>Description</span>

            <textarea
              name="description"
              rows="4"
            >${escapeHTML(
              row.description ||
              ''
            )}</textarea>
          </label>


          <label class="pn8adm-check">

            <input
              type="checkbox"
              name="is_published"
              ${
                row.is_published
                  ? 'checked'
                  : ''
              }
            >

            <span>
              Published
              <small>
                Only published public communities appear publicly.
              </small>
            </span>

          </label>

        </div>


        <div class="pn8adm-form__actions">

          <button
            type="submit"
            class="pn8adm-btn--primary"
          >
            ${
              editing
                ? 'Save changes'
                : 'Create community'
            }
          </button>

          <button
            type="button"
            data-pn8a-close-form
          >
            Cancel
          </button>

        </div>

      </form>
    `;

  }


  function renderEvents(
    rows,
    counts
  ) {

    const target =
      body();


    if (!target) return;


    target.innerHTML = `
      <section class="pn8adm">

        ${managementHeader(
          'events',
          rows.length
        )}

        <div class="pn8adm-grid">

          ${
            rows.length
              ? rows
                  .map(
                    row =>
                      eventCard(
                        row,
                        counts
                      )
                  )
                  .join('')
              : `
                <div class="pn8adm-empty">
                  No events match this view.
                </div>
              `
          }

        </div>

      </section>
    `;

  }


  function renderCommunities(
    rows,
    counts
  ) {

    const target =
      body();


    if (!target) return;


    target.innerHTML = `
      <section class="pn8adm">

        ${managementHeader(
          'communities',
          rows.length
        )}

        <div class="pn8adm-grid">

          ${
            rows.length
              ? rows
                  .map(
                    row =>
                      communityCard(
                        row,
                        counts
                      )
                  )
                  .join('')
              : `
                <div class="pn8adm-empty">
                  No communities match this view.
                </div>
              `
          }

        </div>

      </section>
    `;

  }


  async function loadColleges() {

    if (colleges.length) {
      return colleges;
    }


    try {

      const result =
        await tableRequest(
          'colleges',
          'select=id,name&order=name.asc&limit=500'
        );


      colleges =
        Array.isArray(result)
          ? result
          : [];

    }
    catch (_) {

      colleges = [];

    }


    return colleges;

  }


  async function loadProfiles() {

    if (profiles) {
      return profiles;
    }


    const map =
      new Map();


    try {

      const result =
        await tableRequest(
          'profiles',
          'select=id,full_name,email&limit=1000'
        );


      (
        Array.isArray(result)
          ? result
          : []
      )
        .forEach(
          row =>
            map.set(
              row.id,
              row
            )
        );

    }
    catch (_) {}


    profiles =
      map;


    return profiles;

  }


  async function inspectEvent(
    eventId
  ) {

    const host =
      body()?.querySelector(
        '[data-pn8a-detail-host]'
      );


    if (!host) return;


    host.innerHTML = `
      <div class="pn8adm-detail">
        Loading registrations…
      </div>
    `;


    try {

      const [
        registrations,
        people
      ] =
        await Promise.all([
          tableRequest(
            'event_registrations',
            `select=id,event_id,user_id,status,ticket_code,created_at,confirmed_at,cancelled_at&event_id=eq.${encodeURIComponent(
              eventId
            )}&order=created_at.desc&limit=500`
          ),

          loadProfiles()
        ]);


      const rows =
        Array.isArray(
          registrations
        )
          ? registrations
          : [];


      host.innerHTML = `
        <section class="pn8adm-detail">

          <div class="pn8adm-detail__head">

            <div>
              <small>
                EVENT REGISTRATIONS
              </small>

              <h3>
                ${rows.length}
                registration${rows.length === 1 ? '' : 's'}
              </h3>
            </div>

            <button
              type="button"
              data-pn8a-close-detail
            >
              ×
            </button>

          </div>


          ${
            rows.length
              ? `
                <div class="pn8adm-table-wrap">

                  <table>

                    <thead>
                      <tr>
                        <th>Student</th>
                        <th>Status</th>
                        <th>Ticket</th>
                        <th>Registered</th>
                      </tr>
                    </thead>

                    <tbody>

                      ${rows
                        .map(
                          row => {

                            const profile =
                              people.get(
                                row.user_id
                              );


                            return `
                              <tr>

                                <td>
                                  <strong>
                                    ${escapeHTML(
                                      profile?.full_name ||
                                      'Student'
                                    )}
                                  </strong>

                                  <small>
                                    ${escapeHTML(
                                      profile?.email ||
                                      row.user_id
                                    )}
                                  </small>
                                </td>

                                <td>
                                  ${escapeHTML(
                                    row.status
                                  )}
                                </td>

                                <td>
                                  ${escapeHTML(
                                    row.ticket_code ||
                                    '—'
                                  )}
                                </td>

                                <td>
                                  ${escapeHTML(
                                    dateText(
                                      row.created_at
                                    )
                                  )}
                                </td>

                              </tr>
                            `;

                          }
                        )
                        .join('')}

                    </tbody>

                  </table>

                </div>
              `
              : `
                <div class="pn8adm-empty">
                  No registrations yet.
                </div>
              `
          }

        </section>
      `;

    }
    catch (error) {

      host.innerHTML = `
        <div class="pn8adm-detail">
          ${escapeHTML(
            error?.message ||
            'Could not load registrations.'
          )}
        </div>
      `;

    }

  }


  async function inspectCommunity(
    communityId
  ) {

    const host =
      body()?.querySelector(
        '[data-pn8a-detail-host]'
      );


    if (!host) return;


    host.innerHTML = `
      <div class="pn8adm-detail">
        Loading members…
      </div>
    `;


    try {

      const [
        members,
        people
      ] =
        await Promise.all([
          tableRequest(
            'community_members',
            `select=community_id,user_id,role,status,joined_at&community_id=eq.${encodeURIComponent(
              communityId
            )}&order=joined_at.desc&limit=500`
          ),

          loadProfiles()
        ]);


      const rows =
        Array.isArray(members)
          ? members
          : [];


      host.innerHTML = `
        <section class="pn8adm-detail">

          <div class="pn8adm-detail__head">

            <div>
              <small>
                COMMUNITY MEMBERS
              </small>

              <h3>
                ${rows.length}
                membership${rows.length === 1 ? '' : 's'}
              </h3>
            </div>

            <button
              type="button"
              data-pn8a-close-detail
            >
              ×
            </button>

          </div>


          ${
            rows.length
              ? `
                <div class="pn8adm-table-wrap">

                  <table>

                    <thead>
                      <tr>
                        <th>Student</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Joined</th>
                      </tr>
                    </thead>

                    <tbody>

                      ${rows
                        .map(
                          row => {

                            const profile =
                              people.get(
                                row.user_id
                              );


                            return `
                              <tr>

                                <td>
                                  <strong>
                                    ${escapeHTML(
                                      profile?.full_name ||
                                      'Student'
                                    )}
                                  </strong>

                                  <small>
                                    ${escapeHTML(
                                      profile?.email ||
                                      row.user_id
                                    )}
                                  </small>
                                </td>

                                <td>
                                  ${escapeHTML(
                                    row.role
                                  )}
                                </td>

                                <td>
                                  ${escapeHTML(
                                    row.status
                                  )}
                                </td>

                                <td>
                                  ${escapeHTML(
                                    dateText(
                                      row.joined_at
                                    )
                                  )}
                                </td>

                              </tr>
                            `;

                          }
                        )
                        .join('')}

                    </tbody>

                  </table>

                </div>
              `
              : `
                <div class="pn8adm-empty">
                  No members yet.
                </div>
              `
          }

        </section>
      `;

    }
    catch (error) {

      host.innerHTML = `
        <div class="pn8adm-detail">
          ${escapeHTML(
            error?.message ||
            'Could not load members.'
          )}
        </div>
      `;

    }

  }


  async function enhance(
    tab,
    source
  ) {

    if (
      tab !== 'events'
      &&
      tab !== 'communities'
    ) {
      return;
    }


    const run =
      ++generation;


    currentRows[tab] =
      Array.isArray(source)
        ? source
        : [];


    try {

      if (
        tab === 'events'
      ) {

        const registrations =
          await tableRequest(
            'event_registrations',
            'select=id,event_id,status&limit=2000'
          );


        if (
          run !== generation
          ||
          activeTab() !==
            'events'
        ) {
          return;
        }


        renderEvents(
          currentRows.events,
          eventCounts(
            Array.isArray(
              registrations
            )
              ? registrations
              : []
          )
        );

      }
      else {

        const [
          members
        ] =
          await Promise.all([
            tableRequest(
              'community_members',
              'select=community_id,status&limit=2000'
            ),

            loadColleges()
          ]);


        if (
          run !== generation
          ||
          activeTab() !==
            'communities'
        ) {
          return;
        }


        renderCommunities(
          currentRows.communities,
          communityCounts(
            Array.isArray(
              members
            )
              ? members
              : []
          )
        );

      }


      const metaNode =
        meta();


      if (metaNode) {

        metaNode.textContent =
          `${
            currentRows[tab].length
          } ${
            tab === 'events'
              ? 'event'
              : 'community'
          } record${
            currentRows[tab].length === 1
              ? ''
              : 's'
          } · Live from Supabase`;

      }

    }
    catch (error) {

      console.error(
        '[PeerNest 8A Admin]',
        tab,
        error
      );

    }

  }


  function openForm(
    type,
    row = {}
  ) {

    const host =
      body()?.querySelector(
        '[data-pn8a-form-host]'
      );


    if (!host) return;


    host.innerHTML =
      type === 'event'
        ? renderEventForm(row)
        : renderCommunityForm(row);


    host.scrollIntoView({
      behavior:'smooth',
      block:'start'
    });

  }


  dashboard.addEventListener(
    'click',
    async event => {

      const closeForm =
        event.target.closest(
          '[data-pn8a-close-form]'
        );


      if (closeForm) {

        const host =
          body()?.querySelector(
            '[data-pn8a-form-host]'
          );


        if (host) {
          host.innerHTML = '';
        }


        return;

      }


      const closeDetail =
        event.target.closest(
          '[data-pn8a-close-detail]'
        );


      if (closeDetail) {

        const host =
          body()?.querySelector(
            '[data-pn8a-detail-host]'
          );


        if (host) {
          host.innerHTML = '';
        }


        return;

      }


      const create =
        event.target.closest(
          '[data-pn8a-new]'
        );


      if (create) {

        if (
          create.dataset
            .pn8aNew ===
          'community'
        ) {

          await loadColleges();

          openForm(
            'community'
          );

        }
        else {

          openForm(
            'event'
          );

        }


        return;

      }


      const editEvent =
        event.target.closest(
          '[data-pn8a-edit-event]'
        );


      if (editEvent) {

        const row =
          currentRows.events
            .find(
              item =>
                item.id ===
                editEvent.dataset
                  .pn8aEditEvent
            );


        if (row) {

          openForm(
            'event',
            row
          );

        }


        return;

      }


      const editCommunity =
        event.target.closest(
          '[data-pn8a-edit-community]'
        );


      if (editCommunity) {

        await loadColleges();


        const row =
          currentRows.communities
            .find(
              item =>
                item.id ===
                editCommunity.dataset
                  .pn8aEditCommunity
            );


        if (row) {

          openForm(
            'community',
            row
          );

        }


        return;

      }


      const eventStatus =
        event.target.closest(
          '[data-pn8a-event-status]'
        );


      if (eventStatus) {

        eventStatus.disabled =
          true;


        try {

          await rpc(
            'pn8a_admin_set_event_status',
            {
              p_event_id:
                eventStatus.dataset
                  .pn8aEventStatus,

              p_status:
                eventStatus.dataset
                  .status
            }
          );


          refresh();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not change event status.'
          );


          eventStatus.disabled =
            false;

        }


        return;

      }


      const communityPublish =
        event.target.closest(
          '[data-pn8a-community-publish]'
        );


      if (communityPublish) {

        communityPublish.disabled =
          true;


        try {

          await rpc(
            'pn8a_admin_set_community_published',
            {
              p_community_id:
                communityPublish.dataset
                  .pn8aCommunityPublish,

              p_published:
                communityPublish.dataset
                  .published ===
                'true'
            }
          );


          refresh();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not update community.'
          );


          communityPublish.disabled =
            false;

        }


        return;

      }


      const inspectEventButton =
        event.target.closest(
          '[data-pn8a-inspect-event]'
        );


      if (inspectEventButton) {

        await inspectEvent(
          inspectEventButton.dataset
            .pn8aInspectEvent
        );


        return;

      }


      const inspectCommunityButton =
        event.target.closest(
          '[data-pn8a-inspect-community]'
        );


      if (inspectCommunityButton) {

        await inspectCommunity(
          inspectCommunityButton.dataset
            .pn8aInspectCommunity
        );

      }

    }
  );


  dashboard.addEventListener(
    'submit',
    async event => {

      const eventForm =
        event.target.closest(
          '[data-pn8a-event-form]'
        );


      if (eventForm) {

        event.preventDefault();


        const submit =
          eventForm.querySelector(
            '[type="submit"]'
          );


        submit.disabled =
          true;

        submit.textContent =
          'Saving…';


        try {

          const data =
            new FormData(
              eventForm
            );


          const payload =
            Object.fromEntries(
              data.entries()
            );


          payload.is_paid =
            eventForm.elements
              .is_paid
              .checked;


          payload.starts_at =
            new Date(
              payload.starts_at
            ).toISOString();


          payload.ends_at =
            new Date(
              payload.ends_at
            ).toISOString();


          payload.registration_deadline =
            payload.registration_deadline
              ? new Date(
                  payload.registration_deadline
                ).toISOString()
              : null;


          payload.timezone =
            'Asia/Kolkata';


          payload.currency =
            'INR';


          await rpc(
            'pn8a_admin_upsert_event',
            {
              p_payload:
                payload
            }
          );


          refresh();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not save event.'
          );


          submit.disabled =
            false;

          submit.textContent =
            'Save';

        }


        return;

      }


      const communityForm =
        event.target.closest(
          '[data-pn8a-community-form]'
        );


      if (communityForm) {

        event.preventDefault();


        const submit =
          communityForm.querySelector(
            '[type="submit"]'
          );


        submit.disabled =
          true;

        submit.textContent =
          'Saving…';


        try {

          const data =
            new FormData(
              communityForm
            );


          const payload =
            Object.fromEntries(
              data.entries()
            );


          payload.is_published =
            communityForm.elements
              .is_published
              .checked;


          await rpc(
            'pn8a_admin_upsert_community',
            {
              p_payload:
                payload
            }
          );


          refresh();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not save community.'
          );


          submit.disabled =
            false;

          submit.textContent =
            'Save';

        }

      }

    }
  );


  window.PeerNestAdmin8A = {
    enhance
  };

})();
